<template>
  <div class="pad">
    <mdb-container class="mt-5" v-if="!loading">
      <mdb-row>
        <mdb-col md="12" class="mt-3">
          <mdb-card reverse>
            <mdb-view hover cascade>

              <!--Large banner image on top of article, resized in different rendition for mobile.
                  Banner contains title, author name, and date.                                    -->

              <img :src="`${banner_image}`" class="img-fluid d-none d-md-block"/>
              <img :src="`${banner_image_mobile}`" class="img-fluid d-md-none d-sm-block"/>
              <mdb-mask overlay="white-slight" class="waves-light" waves />
            </mdb-view>
            <mdb-card-body class="text-center" cascade>
              <h2 class="font-weight-bold">
                {{banner_title}}
              </h2>
              <p style="display: inline;"> Written by </p>
              <p v-for="(author, i) in blog_authors" :key="i" style="display: inline;">
                <strong>{{author.author_name}}</strong><strong v-if="(i + 1) != blog_authors.length">, </strong>
              </p>
              <p style="display: inline;">, {{dateToString}}</p>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <!--All other article content.-->

    <template v-for="block in content">
      <component :is="block.type" :block="block" :key="block.id"></component>
    </template>
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbMask,
  mdbView
} from "mdbvue";
import axios from "axios";
import api from "@/api"
import title_and_text from "@/components/PlainComponents/title_and_text.vue";
import full_richtext from "@/components/PlainComponents/full_richtext.vue";
import multiple_image_carousel from "@/components/PlainComponents/multiple_image_carousel.vue";
import image_carousel from "@/components/PlainComponents/image_carousel.vue";
import quote_banner from "@/components/PlainComponents/quote_banner.vue";
import paragraph_and_image from "@/components/PlainComponents/paragraph_and_image.vue";
import call_to_action from "@/views/blog/components/call_to_action.vue";
import document_embed from "@/components/streamfields/document_embed.vue";
import shared from "@/shared";

export default {
  name: "BlogPage",
  props: {
    slug: String
  },
  data() {
    return {
      banner_image: String,
      banner_image_mobile: String,
      banner_title: String,
      blog_authors: Array,
      blog_date: String,
      loading: true,
      content: Array
    };
  },
  mounted() {
    axios
      api.get("pages/" + this.slug)
      .then(response => {
        var blog = response.data;
        this.banner_image = blog.banner_image_big.url;
        this.banner_image_mobile = blog.banner_image_small.url;
        this.banner_title = blog.title;
        this.blog_authors = blog.blog_authors;
        this.blog_date = blog.meta.first_published_at;
        this.content = blog.content;
        shared.getDepartmentSkinFromPage(response.data);
      })
      .catch(e => {
        this.errors.push(e);
      })
      .finally(() => (this.loading = false));
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbMask,
    mdbView,
    title_and_text,
    full_richtext,
    multiple_image_carousel,
    image_carousel,
    quote_banner,
    paragraph_and_image,
    call_to_action,
    document_embed
  },
  computed: {
    dateToString: function() {
      var date = shared.getDate(this.blog_date);
      return date.toLocaleDateString();
    }
  }
};
</script>
